import { render, staticRenderFns } from "./PostFilesDropzone.vue?vue&type=template&id=32177483&lang=pug&"
import script from "./PostFilesDropzone.vue?vue&type=script&lang=js&"
export * from "./PostFilesDropzone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports